import React from 'react';
import type { ReactElement, ReactNode } from 'react';

import { NumberColumnCell } from './TableCell.tsx';
import { TextRow } from './TextRow.tsx';
import type { TextRowData } from './TextRow.tsx';

/**
 * Renders the planned text row in place of the row's content, if there is one. Rows never start a
 * light subtree, so they take no observer ref.
 */
export const TableRow = ({
	children,
	textRow,
}: {
	children?: ReactNode;
	textRow?: TextRowData;
}): ReactElement =>
	textRow ? (
		<TextRow row={textRow} />
	) : (
		<tr>
			<NumberColumnCell />
			{children}
		</tr>
	);
